<template>
  <footer v-if="!cloudCannonFooterContentLoading">
    <main-footer
      :links="links"
      :desktopImageUrl="desktopImageUrl"
      :mobileImageUrl="mobileImageUrl"
      ></main-footer>
    <sub-footer></sub-footer>
  </footer>
</template>
<script>
  import SubFooter from './SubFooter.vue'
  import MainFooter from './MainFooter.vue'
  import fetchable from '@mixins/fetchable'
  import CloudCannonable from '@mixins/CloudCannonable'

  export default {
    mixins: [
      fetchable,
      CloudCannonable
    ],
    components: {
      MainFooter,
      SubFooter
    },
    data() {
      return {
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_FOOTER_CONTENT',
            config: {
              root: true
            }
          }
        ],
        links: [],
      }
    },
    computed: {
      desktopImageUrl() {
        return this.cloudCannonFooterContent.lockup_images.desktop.url
      },
      mobileImageUrl() {
        return this.cloudCannonFooterContent.lockup_images.mobile.url
      }
    }
  }
</script>
